<rask-page
    pageTitle="{{title}}"
    [actionShow]="true"
    [actionFn]="skapaAnbudKontrakt"
    [actionDisabled]="!isKopledaOrVirkeskopa"
    actionTitle="{{texts.laggTillNyttAnbudKontrakt}}"
    noPadding
    [footerShow]="false"
>
    <ng-container headerContent>
        <rask-sok-anbud-kontrakt></rask-sok-anbud-kontrakt>
    </ng-container>
    <rask-anbud-kontrakt-list></rask-anbud-kontrakt-list>
</rask-page>
